/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { MouseEventHandler, ReactNode, useState } from 'react';
import { MenuItem } from 'react-pro-sidebar';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import 'scss/Main.scss';
import './SidebarSelector.scss';
import classNames from 'classnames';

type LanguageSelectorProps<T extends string | number> = {
    icon: ReactNode;
    isSidebarCollapsed?: boolean;
    value: string;
    items: DropDown<T>[];
    onSelect: (element: DropDown<T>) => void;
};

export default function SidebarSelector<T extends string | number>({
    isSidebarCollapsed = false,
    icon,
    value,
    items,
    onSelect,
}: Readonly<LanguageSelectorProps<T>>) {
    const className = 'sidebar-selector';

    const [isOpen, setIsOpen] = useState(false);

    const toggle: MouseEventHandler<HTMLLIElement> = (e) => {
        e.stopPropagation();
        setIsOpen((prev) => !prev);
    };

    return (
        <Dropdown
            direction="end"
            nav={false}
            className={`${className}__dropdown`}
            isOpen={isOpen}
            toggle={(e: any) => toggle(e)}
        >
            <DropdownToggle className={`${className}__toggle unselectable`} tag="span">
                <MenuItem
                    icon={icon}
                    active={isOpen}
                    className={className}
                    onClick={(e) => toggle(e)}
                >
                    {value}
                </MenuItem>
            </DropdownToggle>
            <DropdownMenu
                className={classNames(
                    `${className}__menu`,
                    isSidebarCollapsed
                        ? `${className}__menu_sidebar-collapsed`
                        : `${className}__menu_sidebar-open`
                )}
            >
                {items.map((x) => {
                    return (
                        <DropdownItem onClick={() => onSelect(x)} key={x.id}>
                            {x.name}
                        </DropdownItem>
                    );
                })}
            </DropdownMenu>
        </Dropdown>
    );
}
